import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import SupplementaryInvoiceDetailContMain from "presentation/view/container/SupplementaryInvoice/SupplementaryInvoiceDetailContMain";

CommonEntrypoint(<SupplementaryInvoiceDetailContMain/>)